import { secondsSince } from "./derive";
import { formatAge, formatAgo } from "./format";
import { useNowText } from "./use-now";

/**
 * Листья с подписью прошедшего времени. Часы читают они, а не экран: секундный
 * тик перерисовывает только эти узлы, а не дерево строк вокруг (замер
 * 3000 карточек), и только те, чья подпись действительно сменилась
 * (`useNowText`). Экранный компонент, не UIKit: форматирует доменное время.
 */

/** Возраст в сокращённой записи (`formatAge`) от момента `sinceMs`. */
export function Elapsed({ sinceMs }: { sinceMs: number }) {
  return <>{useNowText((now) => formatAge(secondsSince(sinceMs, now)))}</>;
}

/** Давность момента `tsMs` в той же записи, что `formatAgo` (слово «назад» дописывает вызывающий). */
export function Ago({ tsMs }: { tsMs: number }) {
  return <>{useNowText((now) => formatAgo(tsMs, now))}</>;
}
